<script>
  /**
   * Confirms an email address from the verification link, and signs the user in.
   *
   * Uses core's /auth/verify-email-and-login rather than /auth/verify-email, so
   * a person who clicks the link lands in the portal instead of on a "verified,
   * now go log in" dead end.
   */
  import api from '$lib/api.js';
  import { authStore } from '../stores/authStore.svelte.js';

  let status = $state('verifying');
  let error = $state(null);

  $effect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      status = 'error';
      error = 'This confirmation link is missing its token.';
      return;
    }

    (async () => {
      try {
        const result = await api.verifyEmailAndLogin(token);
        if (!result?.access_token || !result?.user) {
          throw new Error('Link did not return a session');
        }
        authStore.setAuth(result.user, result.access_token);
        await authStore.loadContext().catch(() => null);
        status = 'success';
        setTimeout(() => { window.location.href = '/strao/'; }, 1200);
      } catch (e) {
        status = 'error';
        error = e.message || 'This confirmation link is invalid or has expired.';
      }
    })();
  });
</script>

<div class="flex min-h-screen items-center justify-center px-4">
  <div class="p-card w-full max-w-sm p-8 text-center">
    {#if status === 'verifying'}
      <span class="inline-block h-6 w-6 animate-spin rounded-full border-2 border-current border-t-transparent"
            style="color: var(--p-brand)"></span>
      <p class="mt-4 text-sm p-muted">Confirming your email…</p>
    {:else if status === 'success'}
      <i class="fas fa-circle-check text-2xl" style="color: var(--p-success)" aria-hidden="true"></i>
      <p class="mt-4 text-sm">Email confirmed. Taking you to the portal…</p>
    {:else}
      <i class="fas fa-circle-exclamation text-2xl" style="color: var(--p-danger)" aria-hidden="true"></i>
      <p class="mt-4 text-sm">{error}</p>
      <a href="/strao/login" class="p-btn p-btn-quiet mt-5">Back to sign in</a>
    {/if}
  </div>
</div>
